import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Button,
	Typography,
	Box,
	IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const ModalAddMensajeSolicitud = ({ open, onClose, onSave }) => {
	const [message, setMessage] = useState("");
	const MAX_CHARS = 200;

	const handleChange = (e) => {
		if (e.target.value.length <= MAX_CHARS) {
			setMessage(e.target.value);
		}
	};

	const handleSave = () => {
		onSave(message);
		setMessage(""); // Reset the field after saving
		onClose();
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ m: 0, p: 2 }}>
				Mensaje de solicitud
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent dividers>
				<TextField
					autoFocus
					margin="dense"
					id="message"
					label="Escribe tu mensaje"
					fullWidth
					multiline
					rows={4}
					value={message}
					onChange={handleChange}
					variant="outlined"
					placeholder="Escribe aquí tu mensaje de solicitud..."
				/>
				<Box display="flex" justifyContent="flex-end" mt={1}>
					<Typography variant="caption" color={message.length >= MAX_CHARS ? "error" : "textSecondary"}>
						{message.length}/{MAX_CHARS} caracteres
					</Typography>
				</Box>
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose} color="inherit">
					Cancelar
				</Button>
				<Button onClick={handleSave} color="primary" variant="contained" disabled={message.trim() === ""}>
					Guardar
				</Button>
			</DialogActions>
		</Dialog>
	);
};
